import { combineReducers } from "@reduxjs/toolkit";
import global from "./global";
import auth from "./authReducers";
import dashboard from "./dashboardReducer";
import manageListing from "./manageListingReducer";
import searchListing from "./searchListingReducer";
import rentalSlice from "./rentalsReducer";
import generalSlice from "./generalReducer";
import listingSlice from "./listingReducer";
import addressSlice from "./addressReducer";
import cartSlice from "./cartReducer";
import userSlice from "./userReducer";
import deliveryAddressSlice from "./deliveryAddressReducer";
import bookingSlice from "./bookingReducer";
import personalRentalSlice from "./personalRentalReducer";
import cardSlice from "./cardReducer";
import messagesSlice from "./messagesReducer";
import notificationsSlice from "./notificationReducer";
import documentsSlice from "./documentsReducer";

/**
 * Root reducer of the store
 */
export const allReducers = {
  globalReducer: global,
  authReducer: auth,
  dashboardReducer: dashboard,
  manageListingReducer: manageListing,
  searchListingReducer: searchListing,
  rentalsReducer: rentalSlice,
  generalReducer: generalSlice,

  listingReducer: listingSlice,
  addressReducer: addressSlice,
  cartReducer: cartSlice,
  userReducer: userSlice,
  deliveryAddressReducer: deliveryAddressSlice,
  bookingReducer: bookingSlice,
  personalRentalReducer: personalRentalSlice,
  cardReducer: cardSlice,
  messagesReducer: messagesSlice,
  notificationReducer: notificationsSlice,
  documentsReducer: documentsSlice,
};
const rootReducer = combineReducers(allReducers);
export type RootState = ReturnType<typeof rootReducer>;
